module.exports = __webpack_public_path__ + "static/media/news-20171212001-img01.5e969a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/news-20171212001-img01.png
// module id = 521
// module chunks = 0